import React from 'react'

function Error() {
  return (
    <div>Something went wrong!</div>
  )
}

export default Error
